import { gql } from '@apollo/client';

/**
 * Returns a segment with a list of surveys
 * @return {segment, [surveys]}
 */
export const SEGMENT = gql`
  query Segment($segmentId: ID!) {
    segment(id: $segmentId) {
      id
      name
      audienceParticipants
      device
      operatingSystem
      participantsLanguage
      project {
        participantsSource
      }
      audienceAttributes {
        id
        audienceAttributeType
        audienceAttributeOptions {
          id
          value
          name
        }
      }
      surveys {
        id
        version
      }
    }
  }
`;

/**
 * Returns details questions for a given version of a screener survey
 */
export const SURVEY_DETAILS = gql`
query Survey($id: ID!) {
  survey(id: $id) {
    id
    version
    questions(questionOrder: "asc") {
      id
      label
      questionOrder
      screenerRatingPercentage
      questionOptions(preserveOrder: true) {
        id
        label
        qualify
        disqualify
        optionRatingPercentage
      }
    }
  }
}`;
